export let StringUtility = {
    containsUpperCaseLetter: function (string) {
        return /[A-Z]+/.test(string);
    },

    containsNumber: function (string) {
        return /[\d]+/.test(string);
    },

    containsSpecialCharacter: function (string) {
        return /[-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]+/.test(string);
    },

    isNullOrEmpty: function (string) {
        return !string || ('' + string).trim() === '';
    },

    stringNumberToDisplayCurrency: function (string) {
        const formatter = new Intl.NumberFormat(
            'en-US',
            {
                style: 'currency',
                currency: 'USD',
                maximumFractionDigits: 2,
            }
        );
        return formatter.format(parseFloat('' + string))
    },
};
